(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});



var $2Xzd1 = parcelRequire("2Xzd1");
var $9259829f692d8e81$var$addToCart = {
    init: function() {
        this.buttonOperations();
        this.afterAddToCart();
        jQuery('body').on('updated_cart_totals', function() {
            $9259829f692d8e81$var$addToCart.buttonOperations();
        });
    },
    resetVariationInput: function(addToCart, quantityInput, initialText) {
        addToCart.classList.add('disabled');
        addToCart.textContent = initialText;
        quantityInput.value = 1;
    },
    buttonOperations: function() {
        var _this = this;
        var isProduct = document.querySelector('.single-product, .woocommerce-cart-form__cart-item, .tax-product_cat, .search .products');
        var products = document.querySelectorAll('.product-cart-container, .cart_item');
        var variations = document.querySelector('.variations_form');
        if (!isProduct) return;
        if (variations) {
            var addToCart = document.querySelector('.ajax_add_to_cart');
            var quantityInput = document.querySelector('.add-to-cart__input');
            var select = document.querySelector('.variations_form select');
            var reset = document.querySelector('.reset_variations');
            var addToCartText = addToCart.getAttribute('data-add-to-text');
            var outOfStockText = addToCart.getAttribute('data-out-of-stock-text');
            var selectFromOptionsText = addToCart.getAttribute('data-select-option-text');
            jQuery(document).on("found_variation.first", function(e, variation) {
                if (!variation.is_in_stock) {
                    addToCart.classList.add('disabled');
                    addToCart.textContent = outOfStockText;
                } else {
                    addToCart.classList.remove('disabled');
                    addToCart.textContent = addToCartText;
                }
                var maxQty = variation.max_qty;
                if (maxQty) {
                    quantityInput.setAttribute('max', maxQty);
                    if (quantityInput.value > maxQty) {
                        quantityInput.value = maxQty;
                        addToCart.setAttribute('data-quantity', maxQty);
                    }
                } else quantityInput.setAttribute('max', '');
                addToCart.setAttribute('data-product_id', variation.variation_id);
                addToCart.setAttribute('value', variation.variation_id);
            });
            reset.addEventListener('click', function() {
                _this.resetVariationInput(addToCart, quantityInput, selectFromOptionsText);
            });
            if (!select.value) this.resetVariationInput(addToCart, quantityInput, selectFromOptionsText);
            select.addEventListener('input', function(e) {
                if (!e.target.value) _this.resetVariationInput(addToCart, quantityInput, selectFromOptionsText);
                else addToCart.textContent = addToCartText;
            });
        }
        (0, $2Xzd1._)(products).concat([
            variations
        ]).forEach(function(product) {
            if (!product) return;
            var subtractButton = product.querySelector(".add-to-cart__btn-subtract");
            var addButton = product.querySelector(".add-to-cart__btn-add");
            var quantityInput = product.querySelector(".add-to-cart__input");
            var addToCartButton = product.querySelector(".add_to_cart_button");
            subtractButton === null || subtractButton === void 0 ? void 0 : subtractButton.addEventListener("click", function() {
                var currentValue = parseInt(quantityInput.value) || 0;
                var minValue = quantityInput.getAttribute('min');
                if (currentValue > minValue) {
                    quantityInput.value = currentValue - 1;
                    _this.updateDataQuantity(quantityInput, addToCartButton);
                }
                _this.clickAnimation(subtractButton);
            });
            addButton === null || addButton === void 0 ? void 0 : addButton.addEventListener("click", function() {
                var currentValue = parseInt(quantityInput.value) || 0;
                var maxValue = parseInt(quantityInput.getAttribute("max")) || Infinity;
                if (currentValue < maxValue) {
                    quantityInput.value = currentValue + 1;
                    _this.updateDataQuantity(quantityInput, addToCartButton);
                }
                _this.clickAnimation(addButton);
            });
            quantityInput === null || quantityInput === void 0 ? void 0 : quantityInput.addEventListener("input", function() {
                var minValue = parseInt(quantityInput.getAttribute("min")) || 1;
                var maxValue = parseInt(quantityInput.getAttribute("max")) || Infinity;
                var value = parseInt(quantityInput.value.replace(/\D/g, '')) || minValue;
                if (value < minValue) quantityInput.value = minValue;
                if (value > maxValue) quantityInput.value = maxValue;
                _this.updateDataQuantity(quantityInput, addToCartButton);
            });
            quantityInput === null || quantityInput === void 0 ? void 0 : quantityInput.addEventListener("keypress", function(event) {
                if (!/[0-9]/.test(event.key)) event.preventDefault();
            });
        });
    },
    updateDataQuantity: function(quantityInput, addToCartButton) {
        if (addToCartButton) addToCartButton.setAttribute("data-quantity", quantityInput.value);
        quantityInput.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    // If we want auto-update
    // document.querySelector('.cart_update').click();
    },
    clickAnimation: function(button) {
        button.classList.add("clicked");
        setTimeout(function() {
            button.classList.remove("clicked");
        }, 150);
    },
    afterAddToCart: function() {
        var popup = document.querySelector('.add-to-cart-popup');
        var loader = document.querySelector('.loader-custom');
        var communicat = document.querySelector('.communicat');
        var failed = document.querySelector('.add-to-cart-failed');
        var success = document.querySelector('.add-to-cart-success');
        if (!popup) return;
        jQuery('body').on('adding_to_cart', function(event) {
            popup.classList.add('active');
            loader.classList.add('active');
        });
        jQuery('body').on('added_to_cart', function(event, fragments, cart_hash, button) {
            loader.classList.remove('active');
            communicat.classList.add('active');
            if (cart_hash) {
                var _button_;
                var productName = (_button_ = button[0]) === null || _button_ === void 0 ? void 0 : _button_.getAttribute('data-product-name');
                var productNameLoader = document.querySelector('.loader-product-name');
                productNameLoader.textContent = productName;
                success.classList.add('active');
            } else failed.classList.add('active');
            setTimeout(function() {
                failed.classList.remove('active');
                success.classList.remove('active');
                loader.classList.remove('active');
                communicat.classList.remove('active');
                popup.classList.remove('active');
            }, 1500);
            popup.addEventListener('click', function() {
                popup.classList.remove('active');
            });
        });
    }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
    return $9259829f692d8e81$var$addToCart.init();
});
else $9259829f692d8e81$var$addToCart.init();

})();
//# sourceMappingURL=add-to-cart.js.map
